import { render, staticRenderFns } from "./PointsCenter.vue?vue&type=template&id=2d4dcc65&scoped=true&"
import script from "./PointsCenter.vue?vue&type=script&lang=js&"
export * from "./PointsCenter.vue?vue&type=script&lang=js&"
import style0 from "./PointsCenter.vue?vue&type=style&index=0&id=2d4dcc65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4dcc65",
  null
  
)

export default component.exports